import React from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Route, Link } from "react-router-dom";
import {isHamburguerMenu} from '../../../../utils/objectManipulations'
import logo from "../../../../assets/images/cargill.jpg"
import useStyles from "./styles";
import { fieldLabelTransform } from "../../../../utils/fieldLabelTransform";


const BreadcrumbsComponent = ({ pathnames, menus ,user}) => {
  const classes = useStyles();
  return (
    <Route>
      {isHamburguerMenu(user) &&
      <img src={logo} alt="cargill_logo"className={classes.logo}/>}
      <Breadcrumbs aria-label="Breadcrumb" className={classes.breadcrumb}>
        <Link to="/" className={classes.links}>
          Home
        </Link>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const currentSubRoute = menus.find(menu => menu.route === `/${value}`);
          let to = `/${pathnames.slice(0, index + 1).join("/")}`;
          if(currentSubRoute && currentSubRoute.subRoutes && currentSubRoute.subRoutes.length) {
            to = currentSubRoute.subRoutes[0].route
          }

          if (!last) {
            return (
              <Link to={to} key={to} className={classes.links}>
                {fieldLabelTransform(value) ?? value.replace(/-/g, " ")}
              </Link>
            );
          }
          return null;
        })}
      </Breadcrumbs>
    </Route>
  );
};

export default BreadcrumbsComponent;
